import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { useCollaboration } from '../../../entities/collaboration';
import { Button } from '../../../shared/ui';
import { ThreadItem } from './ThreadItem';
import { EmptyState } from './EmptyState';

enum TagsOptions {
  All_Open = 'all_open',
  AssignedToMe = 'assigned_to_me',
  Resolved = 'resolved',
}

export const CommentsSidebar = () => {
  const { threads } = useCollaboration();
  const [selectedTag, setSelectedTag] = useState<TagsOptions>(
    TagsOptions.All_Open
  );
  const isEmpty = threads.length === 0;

  const threadByTag = useMemo(() => {
    switch (selectedTag) {
      case TagsOptions.Resolved:
        return threads.filter(({ resolved }) => resolved);
      case TagsOptions.All_Open:
        return threads.filter(({ resolved }) => !resolved);
      default:
        return threads;
    }
  }, [threads, selectedTag]);

  const tagsOptions = useMemo(() => {
    return [
      {
        id: TagsOptions.All_Open,
        name: 'All open',
      },
      /*{ // TODO: will be added when mentions ready
      id: TagsOptions.AssignedToMe,
      name: 'Assigned to me',
    },*/ {
        id: TagsOptions.Resolved,
        name: 'Resolved',
      },
    ];
  }, []);

  const handleTagChange = (tag: TagsOptions) => {
    setSelectedTag(tag);
  };

  return (
    <div className="flex flex-col w-100 p-5 gap-5 border-r border-r-gray-200">
      <header>
        <h2 className="text-2xl text-gray-900 font-semibold">Comments</h2>
      </header>
      {isEmpty ? (
        <EmptyState />
      ) : (
        <>
          <nav className="flex items-center gap-1">
            {tagsOptions.map((tag) => (
              <Button
                key={tag.id}
                className={classNames('!rounded-full', {
                  'border-gray-300 bg-gray-200': selectedTag === tag.id,
                })}
                variant="text"
                color="secondary"
                onClick={() => handleTagChange(tag.id)}
              >
                {tag.name}
              </Button>
            ))}
          </nav>
          <section className="overflow-y-auto">
            <div className="flex flex-col gap-4">
              {threadByTag.map((thread) => (
                <ThreadItem key={thread.id} thread={thread} />
              ))}
            </div>
          </section>
        </>
      )}
    </div>
  );
};
